<template>
	<div>
		<h6 class="font-medium">
			{{ value.gender === 'm' ? 'Teilnehmer' : 'Teilnehmerin' }}
		</h6>
		<p>
			{{ value.gender === 'm' ? 'Herr' : 'Frau' }} {{ value.firstname }}
			{{ value.lastname }}, {{ value.position }} ({{ value.email }})
		</p>
	</div>
</template>

<script lang="ts" setup>
import {StudentInterface} from "@/js/interfaces/student"

defineProps<{
	value: StudentInterface
}>()
</script>

<style scoped></style>
